import React, { useState } from 'react';
import ActionStatus from './ActionStatus';
import useManagementAction from './useManagementAction';
import {
    buttonStyle, cardDescriptionStyle, cardStyle, cardTitleStyle, fieldsStyle, fieldStyle, inputStyle, labelStyle, textareaStyle,
} from './styles';

const toBody = (fields, values) => {
    const body = {};
    fields.forEach((field) => {
        const value = values[field.name] ?? '';
        if (field.type === 'number') {
            if (value !== '') body[field.name] = Number(value);
        } else {
            body[field.name] = value;
        }
    });
    return body;
};

/**
 * A button (with optional input fields) that starts a management job on the server,
 * shows a spinner while it runs and the result when it has finished.
 */
const ManagementAction = ({ title, description, endpoint, buttonLabel, fields = [], confirmMessage, wide }) => {
    const [values, setValues] = useState({});
    const { status, message, error, startedAt, running, run } = useManagementAction(endpoint);

    const missingRequired = fields.some((f) => f.required && !String(values[f.name] ?? '').trim());
    const disabled = running || missingRequired;

    const handleSubmit = (e) => {
        e.preventDefault();
        if (disabled) return;
        if (confirmMessage && !window.confirm(confirmMessage)) return;
        run(toBody(fields, values));
    };

    return (
        <form onSubmit={handleSubmit} style={cardStyle(wide)}>
            {title && <h3 style={cardTitleStyle}>{title}</h3>}
            {description && <p style={cardDescriptionStyle}>{description}</p>}

            {fields.length > 0 && (
                <div style={fieldsStyle}>
                    {fields.map((field) => {
                        const id = `${endpoint}-${field.name}`;
                        const common = {
                            id,
                            name: field.name,
                            value: values[field.name] ?? '',
                            placeholder: field.placeholder,
                            disabled: running,
                            onChange: (e) => setValues((prev) => ({ ...prev, [field.name]: e.target.value })),
                        };

                        return (
                            <div key={field.name} style={fieldStyle(field.half)}>
                                {field.label && <label htmlFor={id} style={labelStyle}>{field.label}</label>}
                                {field.type === 'textarea' ? (
                                    <textarea {...common} rows={field.rows ?? 6} style={textareaStyle} />
                                ) : (
                                    <input {...common} type={field.type ?? 'text'} min={field.min} style={inputStyle} />
                                )}
                            </div>
                        );
                    })}
                </div>
            )}

            <button type="submit" style={{ ...buttonStyle(disabled), marginTop: fields.length > 0 ? 'auto' : '0.75rem' }} disabled={disabled}>
                {buttonLabel}
            </button>

            <ActionStatus status={status} message={message} error={error} startedAt={startedAt} />
        </form>
    );
};

export default ManagementAction;
